import { Helmet } from 'react-helmet-async'

import {
  Box, Columns, LoadingModule, PageHeader,
} from '@domain-group/suit-theme'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import { useNumericParams } from '@domain-group/react-hooks'

import useCurrentUser from '@hooks/useCurrentUser'
import useFlipperKey from '@hooks/useFlipperKey'

import generateMediaAndCopyTabBarItems from '@sections/Client/packs/Campaign/utils/generateMediaAndCopyTabBarItems'

import { getCampaignPermissions, getCampaignType } from 'shared/functions/campaign'
import useCampaignSelector from 'shared/hooks/useCampaignSelector'

import BulkSelectBanner from '../BulkSelectBanner'
import Gallery from '../Gallery/Gallery'
import PhotosAndPlansTools from '../PhotosAndPlansTools'
import ProjectMedia from '../ProjectMedia'
import UploadImages from '../UploadImages'
import useCampaignImages from '../../hooks/useCampaignImages'

const PageContent = () => {
  const { campaignId } = useNumericParams()

  const { campaign } = useCampaignSelector()
  const { currentUser } = useCurrentUser()
  const { isEnabled: photosPlansV2 } = useFlipperKey('photos_plans_v2')

  const campaignPermissions = getCampaignPermissions({ user: currentUser, campaignType: getCampaignType(campaign) })

  const campaignImagesPayload = useCampaignImages(campaignId)
  const {
    campaign: { address },
    hasFilteredImages,
    loading,
  } = campaignImagesPayload

  return (
    <>
      <Helmet>
        <title>{address || 'Campaign'} | Photos & Plans</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="media"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={generateMediaAndCopyTabBarItems(campaignId, campaignPermissions)}
        title="Photos & Plans"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.campaign.media.banner" />

            <LoadingModule loading={loading} times={3} />

            <ProjectMedia campaignId={campaignId} />

            {!loading && hasFilteredImages && (
              <>
                <BulkSelectBanner campaignImagesPayload={campaignImagesPayload} />

                <Gallery campaignImagesPayload={campaignImagesPayload} />
              </>
            )}

            {!loading && (!photosPlansV2 || !hasFilteredImages) && (
              <UploadImages campaignId={campaignId} />
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.campaign.media.sidebar" />

            <PhotosAndPlansTools campaignImagesPayload={campaignImagesPayload} />
            {!loading && photosPlansV2 && hasFilteredImages && (
              <UploadImages campaignId={campaignId} />
            )}
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}
export default PageContent
